export default "__VITE_PUBLIC_ASSET__deba3a4a__"